import { render, staticRenderFns } from "./PrintingExplain.vue?vue&type=template&id=b2ed5486&scoped=true&"
import script from "./PrintingExplain.vue?vue&type=script&lang=js&"
export * from "./PrintingExplain.vue?vue&type=script&lang=js&"
import style0 from "./PrintingExplain.vue?vue&type=style&index=0&id=b2ed5486&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ed5486",
  null
  
)

export default component.exports